<template>
    <div>
        <div :style="{width:'100%',height:'290px'}"  style="position: relative">
            <el-amap ref="map" vid="amapDemo" :plugin="plugin"  :amap-manager="amapManager" :center="center" :zoom="zoom"   class="amap-demo">
                <el-amap-marker vid="marker"
                                :position="center"
                                :label="label"
                >
                </el-amap-marker>
            </el-amap>
            <el-button v-if="saveOnOff && saveManageOnOff" size="small" type="primary" @click="funChangeBoll" style="
            position:absolute;font-size: 12px;top: 0%; left: 0%; ">更换场所</el-button>
            <el-button v-if="saveOnOff && saveManageOnOff" size="small" type="warning" @click="funOpenBoll"
                       style="position: absolute;top: 0%; right: 0%;font-size: 12px;">编辑坐标
            </el-button>

        </div>
        <!--        更换场所-->
        <el-dialog
                :visible.sync="changeBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px;text-align: left">更换场所
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveChangeBool()">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="closeChangeBool()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="change" style="margin-top: 20px;">
                    <el-form ref="formlist" :model="formlist" label-width="15%">
                        <div :style="{width:'100%',height:'250px'}" style="text-align: center;position: relative" >
                            <el-amap-search-box style="position: absolute;top: 0;height: 30px;z-index: 999"
                                                class="search-box"
                                                :search-option="searchOption"
                                                :on-search-result="onSearchResult"></el-amap-search-box>
                            <el-amap class="amap-box" vid="map" :plugin="plugin"
                                     :zoom="zoom"
                                     :center="center">
                                <el-amap-marker vid="marker"
                                                :position="center"
                                                :label="label"
                                >
                                </el-amap-marker>
                            </el-amap>

                        </div>
                        <el-row style="margin-top: 20px">
                            <el-col>
                                <el-form-item label="新的场所" >
                                    <el-input v-model="formlist.place" disabled placeholder="请输入内容"></el-input>
                                </el-form-item>
                                <el-form-item label="新的地址" >
                                    <el-input v-model="formlist.addr" disabled placeholder="请输入内容"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>

        </el-dialog>
        <!--        编辑坐标-->
        <el-dialog
                :style="{'display':'none'}"
                :visible.sync="coordinatesBool"
                width="700px"
                :show-close="false"
                style="vertical-align: center;">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px;text-align: left">GPS坐标
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click="saveCoordBool ">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="colseCoordBool()">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div  style="margin-top: 20px;">
                    <el-form ref="formlist" :model="formlist" label-width="15%">
                        <div :style="{width:'100%',height:'250px'}" style="text-align: center;position: relative" >

                            <el-amap class="amap-box" vid="map" :plugin="plugin"
                                     :zoom="zoom"
                                     :events="events"
                                     :center="center">
                                <el-amap-marker vid="marker"
                                                :position="center"
                                                :label="label"
                                >
                                </el-amap-marker>
                            </el-amap>

                        </div>
                        <el-row style="margin-top: 20px">
                            <el-col>
                                <el-form-item label="新的场所" >
                                    <el-input v-model="formlist.place" disabled placeholder="请输入内容"></el-input>
                                </el-form-item>
                                <el-form-item label="新的地址" >
                                    <el-input v-model="formlist.addr" disabled placeholder="请输入内容"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>

        </el-dialog>
    </div>

</template>

<style>
    .amap-demo {
        height: 250px;
    }
</style>

<script>
    import http from '../../../../APIService/http'
    // NPM 方式
    import {AMapManager} from "vue-amap"
    // CDN 方式
    // let amapManager = new VueAMap.AMapManager();
    let amapManager = new AMapManager();
    export default {
        props: {
            data: {
                type: Object,
                default: {
                    center:[121.38878,31.320988],
                }
            },
            fatherMethod: {
                type: Function,
                default: null
            },
            saveOnOff:{
                type: Boolean,
                default: false
            },
            saveManageOnOff:{
                type: Boolean,
                default: false
            }

        },

        data: function() {
            return {
                amapManager,
                zoom: 16,
                center:[],
                centerCopy:[],
                events: {
                    'moveend': () => {
                    },
                    'zoomchange': () => {
                    },
                    'click': (e) => {
                        let lng = e.lnglat.lng
                        let lat = e.lnglat.lat
                        this.center = [lng,lat]
                        console.log(this.center)
                    }
                },
                plugin: [{
                    pName: 'ToolBar',
                    position:'RB',
                    locate:false,
                    events: {
                        init(instance) {

                        }
                    }

                }],
                label:{
                    content:'',
                    offset:[10,12]
                },
                changeBool:false,
                coordinatesBool:true,
                mapOnoff:false,
                formlist:{
                    addr:'',
                    place:''
                },
                formlistCopy:{
                    addr:'',
                    place:''
                },
                markers: [
                    [121.59996, 31.197646],
                    [121.40018, 31.197622],
                    [121.69991, 31.207649]
                ],
                searchOption: {
                    citylimit: true
                },
                activity_id:''
            };
        },
        created(){

        },
        mounted(){
            this.coordinatesBool = false
            let lng = this.data.lng
            let lat = this.data.lat
            this.activity_id = this.data.activity_id
            this.center = [lng,lat]
            console.log(this.center)
            this.formlist.place = this.data.location
            this.formlist.addr = this.data.address
            this.centerCopy = JSON.parse(JSON.stringify(this.center))

        },
        methods: {
            init() {
                var map = new AMap.Map('my_container',{
                    resizeEnable: true,
                    zoom: 18,
                    //   center: [121.542282,29.831995]
                })
                AMap.plugin('AMap.Geolocation',function(){ //异步加载插件
                    var geolocation = new AMap.Geolocation()
                    map.addControl(geolocation)
                })
            },
            getMap() {
                // amap vue component
                console.log(amapManager._componentMap);
                // gaode map instance
                console.log(amapManager._map);
            },
            addMarker: function() {
                let lng = 121.5 + Math.round(Math.random() * 1000) / 10000;
                let lat = 31.197646 + Math.round(Math.random() * 500) / 10000;
                this.markers.push([lng, lat]);
            },
            onSearchResult(pois) {

                let obj = pois[0]

                this.center = [obj.lng, obj.lat];
                this.formlist.addr = obj.address
                this.formlist.place = obj.name
                console.log(this.formlist)
                // console.log(pois)
                // let latSum = 0;
                // let lngSum = 0;
                // if (pois.length > 0) {
                //     pois.forEach(poi => {
                //         let {lng, lat} = poi;
                //         lngSum += lng;
                //         latSum += lat;
                //         this.markers.push([poi.lng, poi.lat]);
                //     });
                //     let center = {
                //         lng: lngSum / pois.length,
                //         lat: latSum / pois.length
                //     };
                //     this.center = [center.lng, center.lat];
                //     console.log(this.center)
                // }
            },
            funChangeBoll(){
                console.log(this.center)
                this.centerCopy = JSON.parse(JSON.stringify(this.center))
                this.formlistCopy = JSON.parse(JSON.stringify(this.formlist))
                this.changeBool = true
            },
            funOpenBoll(){

                this.$nextTick(() => {
                    this.init()
                });
                this.centerCopy = JSON.parse(JSON.stringify(this.center))
                this.coordinatesBool = true
                this.mapOnoff = false
                this.mapOnoff = true
                // 在这里使用$nextTick初始化地图插件即可

            },
           async saveChangeBool(){
                try {
                  let data={
                      tenant_id : this.$store.getters.getUser.tenant_id,
                      location : this.formlist.place,
                      address : this.formlist.addr,
                      postcode : this.data.postcode,
                      telephone :this.data.telephone,
                      website : this.data.website,
                      lng : this.center[0],
                      lat : this.center[1],
                      user_id :this.$store.getters.getUser.user_id,
                      location_id : this.data.location_id,
                      activity_id : this.activity_id ? this.activity_id : ''
                  }
                    console.log(data);
                    await http.post('/wapi/Conference/saveCoordinates',data).then(res=>{
                      if (res.success === true){
                          this.$message({
                              type:'success',
                              message:'保存成功'
                          })
                          this.fatherMethod()
                          this.changeBool = false
                      }
                  })
                }catch (e) {

                }

            },
            closeChangeBool(){
                this.center = JSON.parse(JSON.stringify(this.centerCopy))
                this.formlist = JSON.parse(JSON.stringify(this.formlistCopy))
                this.changeBool = false
                console.log(this.center)
            },
           async saveCoordBool(){
                try {
                    let data={
                        tenant_id : this.$store.getters.getUser.tenant_id,
                        location : this.formlist.place,
                        address : this.formlist.addr,
                        postcode : this.data.postcode,
                        telephone :this.data.telephone,
                        website : this.data.website,
                        lng : this.center[0],
                        lat : this.center[1],
                        user_id :this.$store.getters.getUser.user_id,
                        location_id : this.data.location_id,
                        activity_id : this.activity_id ? this.activity_id : ''
                    }
                    console.log(data)

                    await http.post('/wapi/Conference/saveCoordinates',data).then(res=>{
                        if (res.success === true){
                            this.$message({
                                type:'success',
                                message:'保存成功'
                            })
                            this.$emit('fatherMethod');
                            this.fatherMethod()
                            this.coordinatesBool = false
                        }
                    })
                }catch (e) {

                }


            },
            colseCoordBool(){
                console.log(this.center)
                console.log(this.centerCopy)
                this.center = JSON.parse(JSON.stringify(this.centerCopy))
                console.log(this.center)
                this.coordinatesBool = false
             }

        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/map.vue